<div class="search-wrapper" [class.disable-btn]="isDisabled">
  <label *ngIf="label">
    {{ label }}
    <span *ngIf="isRequired" class="error">*</span>
    <i class="icon-information-16" *ngIf="description" [appTooltip]="description" [tooltipTheme]="'white'" [tooltipMaxWidth]="200"></i>
  </label>
  <div class="search-box-wrapper" (appClickOutside)="opened = false">
    <i class="icon-search-input-default-24"></i>
    <input
      [placeholder]="placeholder"
      [(ngModel)]="searchValue"
      (ngModelChange)="searchValue$.next($event)"
      [class.error-border]="showError"
      (focusin)="focusin()"
      (focusout)="focus = false"
      (click)="click($event)"
      [attr.maxLength]="maxLength > 0 ? maxLength : 'none'"
    />
    <i class="icon-close-default-16" (click)="clear()" *ngIf="searchValue?.length && !showLoader"></i>
    <img class="spinner" src="/assets/icons/Deloitte-Spinner.svg" *ngIf="loader && showLoader" />
    <ng-container *ngIf="opened">
      <ng-container *ngIf="template" [ngTemplateOutlet]="template"></ng-container>
      <div *ngIf="!template">
        <div class="list-wrapper" *ngIf="_list.length">
          <div class="list" [style.max-height]="listMaxHeight + 'px'">
            <div class="list-item" *ngFor="let item of _list" (click)="select(item)">
              <span *ngIf="highlight" [innerHTML]="item.heading | appHighlight : searchValue"></span>
              <span *ngIf="!highlight">{{ item.heading }}</span>
            </div>
          </div>
          <div *ngIf="list.length > overflowLimit" class="warning">
            {{ "Translation.Foundtoomanymatches" | translate }}
          </div>
        </div>
        <div *ngIf="noResultsFound" class="warning">
          {{ "Translation.No_results_found" | translate }}
        </div>
      </div>
    </ng-container>
  </div>
  <div class="error" [style.font-size]="'12px'" *ngIf="showError">{{ errorMessage }}</div>
</div>
